/* ══════════════════════════════════════════════════════════════════
   47X · LANDING 2X1 BAKI-YUJIRO
   Script EXCLUSIVO de /pages/2x1-baki-yujiro.

   PRINCIPIO: el descuento NO se simula nunca. Cada operación toca el
   carrito real de Shopify y despues vuelve a leer /cart.js. Todos los
   importes que se pintan (original, descuento, total, envio gratis)
   salen de esa respuesta, jamas de una constante.

   El estado del armador ES el carrito: al recargar, al volver del
   checkout o al abrir en otra pestaña, se reconstruye leyendo las
   lineas participantes. Por eso no hay storage propio.

   Shopify PARTE una linea de quantity 2 en dos lineas de 1 para poder
   descontar una: por eso aqui se cuentan UNIDADES, nunca lineas.

   Namespace propio BAKI2X1, acotado a #Baki2x1Landing. No registra
   nada global ni pisa listeners de otras paginas.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.BAKI2X1) return;                 /* una sola vez, aunque el editor re-renderice */
  var BAKI2X1 = window.BAKI2X1 = { v: 1 };

  var CUPO = 2;                                /* unidades de la promo */
  var UMBRAL_ENVIO = 139900;                   /* centavos · $1,399 */

  function $(sel, raiz) { return (raiz || document).querySelector(sel); }
  function $$(sel, raiz) { return [].slice.call((raiz || document).querySelectorAll(sel)); }
  function dinero(c) {
    var s = (Math.abs(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + s;
  }

  function arranca(raiz) {
    if (raiz.__b21) return;
    raiz.__b21 = true;

    var participantes = {};                    /* handle -> true */
    try {
      JSON.parse(raiz.getAttribute('data-b21-handles') || '[]')
        .forEach(function (h) { participantes[h] = true; });
    } catch (e) {}

    var cont     = $('[data-b21-cont]', raiz);
    var barra    = $('[data-b21-prog]', raiz);
    var lista    = $('[data-b21-sel]', raiz);
    var aviso    = $('[data-b21-aviso]', raiz);
    var sticky   = $('[data-b21-sticky]', raiz);
    var stTotal  = $('[data-b21-st-total]', raiz);
    var stWas    = $('[data-b21-st-was]', raiz);
    var stSub    = $('[data-b21-st-sub]', raiz);
    var btnFinal = $('[data-b21-final]', raiz);
    var envio    = $('[data-b21-envio]', raiz);
    var envioT   = $('[data-b21-envio-txt]', raiz);
    var envioB   = $('[data-b21-envio-bar]', raiz);
    var modal    = $('[data-b21-modal]', raiz);
    var mLista   = $('[data-b21-modal-lista]', raiz);
    var mWas     = $('[data-b21-modal-was]', raiz);
    var mDesc    = $('[data-b21-modal-desc]', raiz);
    var mTotal   = $('[data-b21-modal-total]', raiz);
    var mEnvio   = $('[data-b21-modal-envio]', raiz);
    var yaSalio  = false;   /* no repetirlo en el mismo llenado */

    var enVuelo = false;
    var carrito = null;

    function di(msg) { if (aviso) aviso.textContent = msg || ''; }

    /* ── lineas del carrito que participan en la promo ── */
    function lineasPromo() {
      if (!carrito || !carrito.items) return [];
      return carrito.items.filter(function (i) {
        return participantes[i.handle] === true;
      });
    }
    function unidades() {
      return lineasPromo().reduce(function (n, i) { return n + i.quantity; }, 0);
    }

    /* ── lectura real del carrito ── */
    function leeCarrito() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (j) { carrito = j; return j; });
    }

    function pinta() {
      var n = unidades();
      var lp = lineasPromo();

      if (cont) cont.textContent = String(n);
      if (barra) barra.style.width = Math.min(100, (n / CUPO) * 100) + '%';

      /* chips de lo elegido · una por unidad, con su boton de quitar */
      if (lista) {
        lista.innerHTML = '';
        lp.forEach(function (item) {
          for (var u = 0; u < item.quantity; u++) {
            var li = document.createElement('li');
            var txt = document.createElement('span');
            txt.textContent = item.product_title.replace(/\s*-\s*OVER PREMIUM/i, '') + ' · ' + (item.variant_title || '');
            var x = document.createElement('button');
            x.type = 'button';
            x.setAttribute('aria-label', 'Quitar ' + item.product_title + ' ' + (item.variant_title || ''));
            x.textContent = '×';
            x.addEventListener('click', function () { quita(item.key, item.quantity); });
            li.appendChild(txt); li.appendChild(x);
            lista.appendChild(li);
          }
        });
      }

      /* estado por card */
      $$('[data-b21-card]', raiz).forEach(function (c) {
        var h = c.getAttribute('data-b21-card');
        var q = lp.filter(function (i) { return i.handle === h; })
                  .reduce(function (a, i) { return a + i.quantity; }, 0);
        c.classList.toggle('is-on', q > 0);
        var num = $('[data-b21-num]', c);
        if (num) num.textContent = q > 0 ? String(q) : '';
        var add = $('[data-b21-add]', c);
        if (add) {
          var lleno = n >= CUPO;
          add.disabled = lleno;
          add.setAttribute('aria-disabled', lleno ? 'true' : 'false');
          add.textContent = lleno ? 'YA TIENES 2' : 'AGREGAR';
        }
      });

      /* importes REALES del carrito */
      var total = carrito ? carrito.total_price : 0;
      var desc  = carrito ? carrito.total_discount : 0;
      var orig  = carrito ? (carrito.original_total_price || total + desc) : 0;

      if (stTotal) stTotal.textContent = dinero(total);
      if (stWas) {
        if (desc > 0) { stWas.textContent = dinero(orig); stWas.hidden = false; }
        else { stWas.textContent = ''; stWas.hidden = true; }
      }

      /* CTA · los textos que pidio Baruc, por numero de unidades */
      if (btnFinal) {
        var listo = (n === CUPO);
        btnFinal.disabled = !listo;
        btnFinal.setAttribute('aria-disabled', listo ? 'false' : 'true');
        if (n === 0)      btnFinal.textContent = 'ELIGE TU PRIMER OVER';
        else if (n === 1) btnFinal.textContent = 'AGREGA EL SEGUNDO Y TE SALE GRATIS';
        else if (n === 2) btnFinal.textContent = 'FINALIZAR COMPRA · ' + dinero(total);
        else              btnFinal.textContent = 'DEJA SOLO 2 PARA LA PROMO';
      }
      if (stSub) {
        if (n === 0)      stSub.textContent = 'El 2X1 se aplica solo, sin código';
        else if (n === 1) stSub.textContent = 'Agrega el segundo y el 2X1 entra automático';
        else if (n === 2) stSub.textContent = desc > 0
              ? 'Ahorraste ' + dinero(desc) + ' · 2X1 aplicado'
              : 'Revisa el carrito, el 2X1 no se refleja aún';
        else              stSub.textContent = n + ' unidades en la bolsa';
      }
      if (sticky) sticky.classList.toggle('is-on', n > 0);

      /* progreso de envio gratis · sobre el total YA descontado */
      if (envio && envioT && envioB) {
        var falta = Math.max(0, UMBRAL_ENVIO - total);
        var pct = Math.min(100, total / UMBRAL_ENVIO * 100);
        envioB.style.width = pct + '%';
        if (total <= 0) {
          envioT.textContent = 'ENVÍO GRATIS DESDE ' + dinero(UMBRAL_ENVIO);
          envio.classList.remove('is-ok');
        } else if (falta > 0) {
          envioT.textContent = 'TE FALTAN ' + dinero(falta) + ' PARA ENVÍO GRATIS';
          envio.classList.remove('is-ok');
        } else {
          envioT.textContent = '¡ENVÍO GRATIS DESBLOQUEADO!';
          envio.classList.add('is-ok');
        }
      }
    }

    /* ── POPUP DE PAGO ──
       Salta cuando el cliente completa sus 2, y solo una vez por llenado:
       si baja a 1 y vuelve a 2, vuelve a salir; si recarga con 2 ya en la
       bolsa, NO salta (sería una emboscada al entrar). */
    function abreModal() {
      if (!modal) return;
      var lp = lineasPromo();
      var total = carrito ? carrito.total_price : 0;
      var desc  = carrito ? carrito.total_discount : 0;
      var orig  = carrito ? (carrito.original_total_price || total + desc) : 0;

      if (mLista) {
        mLista.innerHTML = '';
        lp.forEach(function (item) {
          for (var u = 0; u < item.quantity; u++) {
            var li = document.createElement('li');
            li.textContent = item.product_title.replace(/\s*-\s*OVER PREMIUM/i, '') + ' · talla ' + (item.variant_title || '');
            mLista.appendChild(li);
          }
        });
      }
      if (mWas)   mWas.textContent   = dinero(orig);
      if (mDesc)  mDesc.textContent  = desc > 0 ? '−' + dinero(desc) : dinero(0);
      if (mTotal) mTotal.textContent = dinero(total);
      if (mEnvio) {
        var falta = Math.max(0, UMBRAL_ENVIO - total);
        mEnvio.textContent = falta > 0
          ? 'Te faltan ' + dinero(falta) + ' para envío gratis'
          : 'Envío gratis desbloqueado';
      }
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var pagar = $('[data-b21-modal-pagar]', modal);
      if (pagar) { try { pagar.focus(); } catch (e) {} }
    }
    function cierraModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }
    if (modal) {
      ['[data-b21-modal-x]', '[data-b21-modal-bg]', '[data-b21-modal-seguir]'].forEach(function (sel) {
        var el = $(sel, modal);
        if (el) el.addEventListener('click', cierraModal);
      });
      var mPagar = $('[data-b21-modal-pagar]', modal);
      if (mPagar) mPagar.addEventListener('click', function () {
        if (unidades() !== CUPO) { cierraModal(); return; }
        mPagar.textContent = 'UN MOMENTO…';
        window.location.href = '/checkout';
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) cierraModal();
      });
    }

    /* El tema pinta el contador de la bolsa por su cuenta. Como aquí se
       agrega por fetch, hay que avisarle o el header se queda en 0 con
       prendas dentro. Son los mismos eventos que usa la landing DSX47. */
    function avisaAlTema(agregado) {
      try { document.dispatchEvent(new CustomEvent(agregado ? 'cart47:added' : 'cart47:refresh')); } catch (e) {}
      /* El contador de la bolsa del header no se refresca con adds por AJAX
         en ninguna parte de la tienda: es comportamiento previo del tema. En
         otras landings casi no se nota porque redirigen a /cart; aquí el
         cliente se queda en la página y vería «0» con dos prendas dentro.
         Se corrige SOLO desde este script, que únicamente carga en esta
         página: el header y el resto del tema no se tocan. */
      try {
        var badge = document.querySelector('.hdr47__cart-count');
        if (badge && carrito) badge.textContent = String(carrito.item_count);
      } catch (e) {}
    }

    function refresca(agregado) {
      return leeCarrito()
        .then(function () { pinta(); avisaAlTema(agregado); })
        .catch(function () { pinta(); });
    }

    /* ── agregar una unidad ── */
    function agrega(variante, boton) {
      if (enVuelo) return;
      if (unidades() >= CUPO) { di('Ya tienes tus 2 overs'); return; }
      yaSalio = false;   /* este llenado todavía no ha mostrado el popup */
      enVuelo = true;
      var prev = boton ? boton.textContent : '';
      if (boton) { boton.textContent = 'AGREGANDO…'; boton.disabled = true; }
      di('');
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'cart'); });
          return r.json();
        })
        .then(function () { return refresca(true); })
        .then(function () {
          if (unidades() === CUPO && !yaSalio) { yaSalio = true; abreModal(); }
        })
        .catch(function (err) {
          di(String(err.message || '').slice(0, 90) || 'No pudimos agregarla · intenta de nuevo');
          if (boton) boton.textContent = prev;
        })
        .then(function () { enVuelo = false; });
    }

    /* ── quitar una unidad de una linea ── */
    function quita(key, cantidadActual) {
      if (enVuelo) return;
      enVuelo = true;
      di('');
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, cantidadActual - 1) })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (j) { carrito = j; pinta(); avisaAlTema(false); if (unidades() < CUPO) yaSalio = false; })
        .catch(function () { di('No pudimos quitarla · intenta de nuevo'); })
        .then(function () { enVuelo = false; });
    }

    /* ── tallas y botones de cada card ── */
    $$('[data-b21-card]', raiz).forEach(function (card) {
      var tallas = $$('[data-b21-size]', card);
      tallas.forEach(function (b) {
        if (b.disabled) return;
        b.addEventListener('click', function () {
          tallas.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          card.setAttribute('data-b21-variante', b.getAttribute('data-b21-variante'));
          di('');
        });
      });
      var add = $('[data-b21-add]', card);
      if (add) add.addEventListener('click', function () {
        var v = card.getAttribute('data-b21-variante');
        if (!v) { di('Elige la talla antes de agregar'); return; }
        agrega(v, add);
      });
    });

    /* ── CTA final · manda al checkout con el total real ── */
    if (btnFinal) btnFinal.addEventListener('click', function () {
      if (btnFinal.disabled || unidades() !== CUPO) return;
      btnFinal.textContent = 'UN MOMENTO…';
      window.location.href = '/checkout';
    });

    /* Al volver con el boton atras el navegador sirve la pagina de cache:
       se relee el carrito para no quedarse con un estado viejo. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresca(); });

    refresca();
  }

  /* ── Cupón TACO20 fuera de ESTA landing ──
     El CSS ya lo oculta; esto además lo saca del DOM para que no quede
     accesible al teclado ni a un lector de pantalla. Va acotado a este
     script, que solo carga en esta página: el chatbot y el cupón siguen
     funcionando igual en el resto de la tienda.
     El popup aparece por temporizador, así que se vigila un rato corto
     y luego se suelta el intervalo. */
  function sinCupon() {
    var quitados = 0;
    /* Cupón TACO20: aquí no aplica (ver el CSS). */
    $$('[data-asis47-coupon][data-mode="coupon"]').forEach(function (el) {
      if (el.parentNode) { el.parentNode.removeChild(el); quitados++; }
    });
    /* Popup global de bienvenida: tapa la oferta en la primera visita.
       Se saca del DOM para que tampoco quede accesible al teclado.
       NO se toca su sessionStorage: en Home y demás sigue apareciendo. */
    $$('[data-pop47]').forEach(function (el) {
      if (el.parentNode) { el.parentNode.removeChild(el); quitados++; }
    });
    return quitados;
  }
  function vigilaCupon() {
    sinCupon();
    var t0 = 0;
    var id = setInterval(function () {
      sinCupon();
      t0 += 700;
      if (t0 >= 45000) clearInterval(id);
    }, 700);
  }

  function init() { $$('[data-b21-root]').forEach(arranca); if ($('[data-b21-root]')) vigilaCupon(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
  /* El editor de temas re-inyecta la seccion: se vuelve a arrancar, pero
     arranca() ignora las raices que ya tienen su marca. */
  document.addEventListener('shopify:section:load', init);
  BAKI2X1.init = init;
})();
